function isFacebookOrInstagramApp() {
    const ua = window.navigator.userAgent || window.navigator.vendor || window.opera;

    return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1) || (ua.indexOf('Instagram') > -1) || (ua.indexOf('Facebook') > -1);
};

function isInApp() {
    const ua = window.navigator.userAgent || window.navigator.vendor || window.opera;
    const rules = [
      'WebView',
      '(iPhone|iPod|iPad)(?!.*Safari\/)',
      'Android.*(wv)',
    ];

    const regex = new RegExp(`(${rules.join('|')})`, 'ig');

    return Boolean(ua.match(regex));
};

function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export {
    isFacebookOrInstagramApp,
    isInApp,
    isIOS
};
